import { commonEnvironment } from './environment.common';
import { orignalEnvironmentPord } from './orignal/orignal-environment.prod';

const apiUrl = window.location.origin;

export const environment = {
  production: true,
  common: {
    tenant: '9',
    ...commonEnvironment,
  },
  version: 'prod.20260407.1',
  /**是否为prod环境 */
  //@ts-ignore
  isOnline: 'true' == 'true',
  /**是否是sit环境 */
  //@ts-ignore
  isSit: 'false' == 'true',
  /**是否是uat环境 */
  //@ts-ignore
  isUat: 'false' == 'true',
  apiUrl: apiUrl,
  resourceUrl: '#{resourceUrl}#',
  signalrUrl: apiUrl + '/ws',
  chatSignalrUrl: apiUrl + '/im/ws',
  rsaPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoTgcVORkxBPRQJimRKTUHrSS+vTBzbAm8l6bwaFqr1Mya/pjsHrUPCErJnchMfmfgEBFrsfX5/FLGfXvKFT//F949jgcl3My2oGCOk4dTh+zpp16q8e0qoOG5JtKmQjs2W+s2sAp2Xsk4hMfRY9ZzxsSORjS6YYvgLb0TwbLXZ1GAHhwJSVJS38AUqJH2Z0ng7xzDAklEqLfcP+99PBVau0iqRBEypUsJqcTPXTJMQw0wZg3Frci0SuOhTexmG7NzVhHZIV0cp07czo8lp8+2YvC14iaPwn2xB4dVXNtIILQFXorfNS9U+IO5uL0Y432GeWax1tVXrl6jowihrd1nwIDAQAB',
  /**原创相关 */
  orignal: orignalEnvironmentPord,
  cacheKey: '3',
  /**是否为App */
  isApp: false,
  translateUrl: '/configs3/LanguageTranslate/Web9/[lang].json,/configs2/LanguageTranslate/Web9/[lang].json,/configs/LanguageTranslate/Web9/[lang].json',
  configUrls: '/configs3/web-[tenant].json,/configs2/web-[tenant].json,/configs/web-[tenant].json',
  sentryDsn: 'https://f31d2508a259fc595f3d5fb10e72300e@sentry.athena25.com/4',
};
